import { ActivityOpenGraph } from './og';
import { FC } from 'react';
import { AbsPageSharingCard } from '@lemon8/web-app-shared/ssr';
import { ActivityFacebookALMeta } from './facebook';
import { ActivityTDK } from './tdk';
import { ActivityTwitter } from './twitter';

export class SharingCardMeta extends AbsPageSharingCard {
  PageLevelTDK: FC = () => {
    return <ActivityTDK />;
  };
  PageLevelOGCard: FC = () => {
    return <ActivityOpenGraph />;
  };
  PageLevelTWCard: FC = () => {
    return <ActivityTwitter />;
  };
  PageLevelALMeta: FC = () => {
    return <ActivityFacebookALMeta />;
  };
}
